import { Flex } from 'antd';
import { Dropdown } from '@/components/AntdCompatDropdown';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TimePeriodPillsProps } from '../type';
import { CustomizeFilterCalendar } from '@/components';
import { ChevronDownIcon } from '@/assets/icons/icons';
import { parseCustomRange } from '../utils/buildHistoryPayload';

const TimePeriodPills: React.FC<TimePeriodPillsProps> = ({
  selectedPeriod,
  onChange,
  showLastWeek = false,
}) => {
  const { t } = useTranslation('aiHistory');
  const [customOpen, setCustomOpen] = useState(false);

  const periodList = [
    { key: 'last_7_days', label: t('last7Days') },
    ...(showLastWeek ? [{ key: 'last_week', label: t('lastWeek') }] : []),
    { key: 'last_30_days', label: t('last30Days') },
    { key: 'month_to_date', label: t('monthToDate') },
    { key: 'year_to_date', label: t('yearToDate') },
    { key: 'all_time', label: t('allTime') },
    { key: 'custom', label: t('customDateRange') },
  ];

  const customSelected = parseCustomRange(selectedPeriod);
  const calendarOverlay = (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <CustomizeFilterCalendar
        dateFilter='ai_history'
        editingId={customSelected ? JSON.stringify(customSelected) : undefined}
        showReportingPeriod={false}
        handleDataFromChild={(payload) => {
          onChange(payload?.newId);
          setCustomOpen(false);
        }}
      />
    </div>
  );

  return (
    <Flex gap={4} wrap>
      {periodList.map((p) => {
        const isCustom = p.key === 'custom';
        const isActive =
          selectedPeriod === p.key || (isCustom && !!customSelected);

        if (!isCustom) {
          return (
            <button
              key={p.key}
              type='button'
              className={`ai-history-time-pills ${isActive ? 'active-pill' : ''}`}
              onClick={() => {
                setCustomOpen(false);
                onChange(p.key);
              }}
            >
              {p.label}
            </button>
          );
        }

        return (
          <Dropdown
            key='custom'
            visible={customOpen}
            onVisibleChange={setCustomOpen}
            trigger={['click']}
            placement='bottomLeft'
            overlayClassName='ai-history-custom-date-dropdown'
            overlay={calendarOverlay}
            destroyPopupOnHide
          >
            <button
              type='button'
              className={`ai-history-time-pills ${isActive ? 'active-pill' : ''}`}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
            >
              {p.label}
              <ChevronDownIcon
                size={18}
                color={isActive ? 'var(--surface-base)' : 'var(--text-primary)'}
              />
            </button>
          </Dropdown>
        );
      })}
    </Flex>
  );
};

export default TimePeriodPills;
